const deleteFragmentModal = {
  bindings: {
    fragment: '<',
    workspace: '<',
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/fragments/delete-fragment-modal/delete-fragment-modal.html',
  controller: 'DeleteFragmentModalController',
};

angular
  .module('pis-tool.module')
  .component('deleteFragmentModal', deleteFragmentModal);
